import React from "react";
import LeadsContent from "../components/leads/leads-content";

const QFSLeads = () => {
  return <LeadsContent qfsOnly={true} pageTitle="QFS Leads" />;
};

export default QFSLeads;
